<div class="container d-none d-md-block">
    <ngx-slick-carousel class="trust-factor-slider carousel" #slickModal="slick-carousel" [config]="slideConfig">
        <div ngxSlickItem *ngFor="let slide of slides" class="slide">
            <div class="slides">
                <div class="slide-image"
                    [ngStyle]="{background: 'url('+ slide.image + ')' + 'no-repeat center / cover,#ffffff'}">
                </div>
                <div class="slider-content px-2">
                    <div class="heading_16 mb-2">
                        {{slide.heading}}
                    </div>
                    <div class="description_16">
                        {{slide.description}}
                    </div>
                </div>
            </div>
        </div>
    </ngx-slick-carousel>
</div>

<div class="container d-md-none d-block">
    <ngx-slick-carousel class="trust-factor-slider carousel" #slickModal="slick-carousel" [config]="slideConfig">
        <div ngxSlickItem *ngFor="let pair of groupedSlides" class="slide col-12">
            <div class="row trust-factor-slider-row">
                <div class="col-12" *ngFor="let slide of pair">
                    <div class="slides">
                        <div class="slide-image"
                            [ngStyle]="{background: 'url('+ slide.image + ')' + 'no-repeat center / cover,#ffffff'}">
                        </div>
                        <div class="slider-content px-2">
                            <div class="heading_16 mb-2">
                                {{slide.heading}}
                            </div>
                            <div class="description_16">
                                {{slide.description}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ngx-slick-carousel>
</div>
